import React, { useEffect } from "react";
import { IonDatetime, IonIcon, IonLabel } from "@ionic/react";
import { IArrivalProps } from "../../../schemas/StartTrip/StartTrip";
import { LoadStopModel } from "./loadStopUtil";
import { getYearValues } from "../../../utils/formatData";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dayjs } from "../../../utils/Date/DateUtil";

const model: LoadStopModel = new LoadStopModel();
export const Arrival: React.FunctionComponent<IArrivalProps> = (
  props: IArrivalProps
) => {
  const arrivalDate = model.getArrival(props.loadStop, props.isNextStop);
  const arrivalReadOnly = model.isArrivalReadonly(props.loadStop);
  const yearVales = getYearValues();
  const { t } = useTranslation();

  useEffect(() => {
    props.onChange(arrivalDate);
  }, [arrivalDate, props.shipmentId, props.timestamp]);

  return (
    <>
      <IonLabel className="arrival-label ">
        {t(model.getArrivalLabelName(props.loadStop, props.isNextStop))}
      </IonLabel>
      {props.isWeb ? (
        <div className={`date-picker-web`}>
          <DatePicker
            onChange={(e: Date) => {
              const arrdate = arrivalDateCheck(e);
              props.onChange(arrdate);
            }}
            onCalendarClose={() => props.onBlur(props.value)}
            dateFormat="MMM d, yyyy hh:mm aa"
            className={`date-time-picker custom-class ${
              arrivalReadOnly || props.isNextStop
                ? "date-time-picker-disabled"
                : ""
            } ${props.isError ? "execution-validation-error" : ""}`}
            showTimeSelect
            timeIntervals={5}
            selected={(props.value && new Date(props.value)) || null}
            disabled={getArrivalcheck(arrivalReadOnly, props)}
          />
          <IonIcon src="assets/icon/calender.svg" className="calender-icon" />
        </div>
      ) : (
        <IonDatetime
          readonly={getArrivalcheck(arrivalReadOnly, props)}
          disabled={getArrivalcheck(arrivalReadOnly, props)}
          displayFormat="MMM DD hh:mm A"
          pickerFormat="YYYY MMM DD hh:mm A"
          value={props.value}
          minuteValues="00,05,10,15,20,25,30,35,40,45,50,55"
          onIonChange={(e) => {
            if (e.detail.value) {
              props.onChange(e.detail.value);
              !props?.loadStop?.actualArrivalDateTime && props.onBlur(e.detail.value);
            }
          }}
          yearValues={yearVales}
          className={`start-trip-location4 execution-field arrival-width2 ${
            arrivalReadOnly ? "hide-border" : ""
          } ${props.isError ? "execution-validation-error" : ""}`}
          mode="ios"
        />
      )}
    </>
  );
};
function getArrivalcheck(
  arrivalReadOnly: boolean,
  props: IArrivalProps
): boolean {
  return arrivalReadOnly || props.isNextStop;
}

function arrivalDateCheck(e: Date) {
  return e === null
    ? dayjs()
        .format()
        .toString()
    : dayjs(e)
        .format()
        .toString();
}
